var React = require('react');

function IconInfo (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"13","cy":"13","r":"12","stroke":"#2C4A43","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M13.0096 8.38C12.6496 8.38 12.3496 8.272 12.1096 8.056C11.8816 7.828 11.7676 7.546 11.7676 7.21C11.7676 6.874 11.8816 6.598 12.1096 6.382C12.3496 6.154 12.6496 6.04 13.0096 6.04C13.3696 6.04 13.6636 6.154 13.8916 6.382C14.1316 6.598 14.2516 6.874 14.2516 7.21C14.2516 7.546 14.1316 7.828 13.8916 8.056C13.6636 8.272 13.3696 8.38 13.0096 8.38ZM12.0556 19V10.072H13.9636V19H12.0556Z","fill":"#2C4A43","key":1})]);
}

IconInfo.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = IconInfo;

IconInfo.default = IconInfo;
